import { useQuery } from '@tanstack/react-query';

import { getLentLoans } from '@/api/loans';
import { AddressType } from 'types';

const useLentLoans = (address: AddressType | undefined) => {
  return useQuery({
    queryKey: ['lent_loans', address],
    queryFn: () => getLentLoans({ address: address! }),
    enabled: !!address,
  });
};

export default useLentLoans;
